<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'Secondary'
}
</script>

<style scoped>

</style>
